import { assert } from './assert';

export function exhaustiveFail(dummy: never, message = 'exhaustive check fails on value:'): never {
  assert(false, message, dummy);
  return dummy;
}
